/* eslint-disable camelcase */
import { all, select, call, fork, put, takeLatest, takeEvery, delay } from "redux-saga/effects";
import { API } from "aws-amplify";
import { upperFirst } from "../../helpers/Utils";

import {
  BOOKING_ADD_ITEM,
  BOOKING_CREATE_ITEM,
  BOOKING_GET_LIST_DELTA,
  BOOKING_INVOKE_KEY,
  EASEE_GET_ADMIN_USERS,
} from "../actions";

import {
  getBookingListDeltaSuccess,
  getBookingListDeltaError,
  addBookingItemSuccess,
  addBookingItemError,
  createBookingItemSuccess,
  createBookingItemError,
  addBookingItemBeforeApiRequestSuccess,
  invokeBookingKeylessKeySuccess,
  invokeBookingKeylessKeyError,
  easeeGetAdminUsersSuccess,
  easeeGetAdminUsersError
} from "./actions";

// import bookingData from '../../data/bookings.json';

const BOOKINGS_BASE = "/users/bookings";
const INVOKE_KEY = "/keyless/endpoint-invitation";

export const addSoftFields = (item, locale = "en", timeZone = "Europe/Istanbul") => {
  const toReturn = item;

  if (!timeZone || timeZone === undefined) {
    timeZone = "Europe/Istanbul";
  }

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h24",
    hour12: false,
    timeZone
  };
  const optionsWithSecond = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h24",
    hour12: false,
    timeZone
  };

  if (toReturn.updated_at) {
    toReturn.updated_at_date = new Date(toReturn.updated_at * 1000).toLocaleDateString(locale, optionsWithSecond);
  }
  if (toReturn.created_at) {
    toReturn.created_at_date = new Date(toReturn.created_at * 1000).toLocaleDateString(locale, options);
  }

  const { user } = item;
  if (user) {
    toReturn.fullName = `${upperFirst(user.name)} ${upperFirst(user.family_name)}`;
  } else if (item.name && item.family_name) {
    toReturn.fullName = `${upperFirst(item.name)} ${upperFirst(item.family_name)}`;
  }
  // delete toReturn.user;

  return toReturn;
};

export const mapBookingResult = (bookings, locale, timeZone) => {
  if (bookings instanceof Array) {
    if (bookings.length === 1) {
      const booking = addSoftFields(bookings[0], locale, timeZone);
      return [booking];
    }
    return bookings.map(item => {
      return addSoftFields(item, locale, timeZone);
    });
  }
  if (bookings instanceof Object) {
    return addSoftFields(bookings, locale, timeZone);
  }

  return [];
};

export function* getEaseeAdminUserWithIdSaga({ payload }, api = API) {
  try {
    const state = yield select();
    const { locale } = state.settings;
    const { timeZone } = state.settings.hotelConfig;
    const { allowedRequestTypes } = state.auth.userPrivileges;
    const { hotelId } = state.settings.hotelConfig;
    const response = yield call(getEaseeAdminUserWithIdRequest, payload, api, locale, timeZone, allowedRequestTypes, hotelId);
    yield put(easeeGetAdminUsersSuccess(response));
  } catch (error) {
    // console.error('error in getRequestWithIdSaga', error);
    yield put(easeeGetAdminUsersError(error));
  }
}

export const invokeKeylessAsync = async payload => {
  const apiName = "WebeeAPI";
  const path = `${INVOKE_KEY}/${payload}`;
  const myInit = {
    pathParameters: {
      id: payload
    }
  };
  try {
    const result = await API.del(apiName, path, myInit);
    return result;
  } catch (err) {
    // console.error('invoke key error in async', err);
    throw err;
  }
};

export const getBookingListDeltaAsync = async (cachedList, api = API, hotelId, timeZone, locale, fetchMore) => {
  const myInit = {
    queryStringParameters: {
      hotel_id: hotelId
    }
  };

  if (fetchMore && cachedList.length) {
    myInit.queryStringParameters.last_updated_at_max = Math.min(...cachedList.map(({ updated_at }) => updated_at));
  } else {
    myInit.queryStringParameters.last_updated_at = cachedList.length ? Math.max(...cachedList.map(({ updated_at }) => updated_at)) : 1;
  }

  try {
    const result = await api.get("WebeeAPI", BOOKINGS_BASE, myInit);
    return mapBookingResult(result, locale, timeZone);
  } catch (err) {
    throw err;
  }
};

export const getEaseeAdminUserWithIdRequest = async (payload, api = API, locale, timeZone, allowedRequestTypes, hotel_id) => {
  try {
    const apiName = "WebeeAPI";
    const path = `/utilities/easee`;
    const myInit = {
      queryStringParameters: {
        hotel_id
      }
    };
    const result = await api.get(apiName, path, myInit);
    return mapBookingResult(result, locale, timeZone);
  } catch (err) {
    // console.error('RequestErr in getRequestWithIdRequest', err);
    throw err;
  }
};

export function* invokeKey({ payload }) {
  try {
    // const state = yield select();
    // const { hotelId, timeZone } = state.settings.hotelConfig;
    const response = yield call(invokeKeylessAsync, payload);
    yield put(invokeBookingKeylessKeySuccess(response));
  } catch (error) {
    // console.error('invoke Key error:', error);
    yield put(invokeBookingKeylessKeyError({ error }));
  }
}

export function* watchInvokeKey() {
  yield takeEvery(BOOKING_INVOKE_KEY, invokeKey);
}

export function* getBookingListItemsDelta({ payload: fetchMore }, api = API) {
  try {
    yield delay(500);
    const state = yield select();
    const {
      locale,
      hotelConfig: { hotelId, timeZone }
    } = state.settings;
    const response = yield call(getBookingListDeltaAsync, Object.values(state.bookingApp.allBookingItems), api, hotelId, timeZone, locale, fetchMore);
    yield put(getBookingListDeltaSuccess(response, fetchMore));
  } catch (error) {
    yield put(getBookingListDeltaError(error));
  }
}

export function* watchGetListDelta() {
  yield takeLatest(BOOKING_GET_LIST_DELTA, getBookingListItemsDelta);
  // yield all([takeLatest(BOOKING_GET_LIST_DELTA, getBookingListItemsDelta)]);
  // yield takeEvery(BOOKING_GET_LIST_DELTA, getBookingListItemsDelta);
}

export const addBookingItemRequest = async (payload, api = API, locale, timeZone) => {
  try {
    // const hotelId = '78';
    // const apiName = 'WebeeAPI';
    const bookingId = payload.id;
    const path = `${BOOKINGS_BASE}/${bookingId}`;
    const result = await api.patch("WebeeAPI", path, { body: payload });
    return mapBookingResult(result, locale, timeZone);
  } catch (err) {
    throw err;
  }
};

export function* addBookingItem({ payload }, api = API) {
  let snapshot;
  try {
    snapshot = yield select(state => state.bookingApp);
    const bookingId = payload.id;
    const modifiedBooking = JSON.parse(JSON.stringify(snapshot.allBookingItems[bookingId]));

    Object.keys(payload).forEach(key => {
      if (payload[key] && modifiedBooking[key] !== payload[key]) {
        modifiedBooking[key] = payload[key];
      }
    });
    yield put(addBookingItemBeforeApiRequestSuccess(modifiedBooking));

    const { locale } = yield select(state => state.settings);
    const { timeZone } = yield select(state => state.settings.hotelConfig);
    const response = yield call(addBookingItemRequest, payload, api, locale, timeZone);
    yield put(addBookingItemSuccess(response));
  } catch (error) {
    yield put(addBookingItemError({ snapshot, error }));
  }
}

export function* wathcAddItem() {
  yield takeEvery(BOOKING_ADD_ITEM, addBookingItem);
}

export const createBookingItemRequest = async (payload, api = API, locale, timeZone) => {
  try {
    // const hotelId = '78';
    // const apiName = 'WebeeAPI';
    const path = `${BOOKINGS_BASE}`;
    const result = await api.post("WebeeAPI", path, { body: payload });
    // return mapBookingResult(result, locale, timeZone);
  } catch (err) {
    throw err;
  }
};

export function* createBookingItem({ payload }, api = API) {
  // let snapshot;
  try {
    // snapshot = yield select(state => state.bookingApp);
    // const bookingId = payload.id;
    // const modifiedBooking = JSON.parse(JSON.stringify(snapshot.allBookingItems[bookingId]));

    // Object.keys(payload).map(key => {
    //   if (payload[key] && modifiedBooking[key] !== payload[key]) {
    //     modifiedBooking[key] = payload[key];
    //   }
    // });
    // yield put(addBookingItemBeforeApiRequestSuccess(modifiedBooking));

    const { locale } = yield select(state => state.settings);
    const { timeZone } = yield select(state => state.settings.hotelConfig);
    const response = yield call(createBookingItemRequest, payload, api, locale, timeZone);
    yield put(createBookingItemSuccess(response));
  } catch (error) {
    yield put(createBookingItemError({ error }));
  }
}

export function* wathcCreateItem() {
  yield takeEvery(BOOKING_CREATE_ITEM, createBookingItem);
}
export function* wathcEaseeGetAdminUser() {
  yield takeEvery(EASEE_GET_ADMIN_USERS, getEaseeAdminUserWithIdSaga);
}

export default function* rootSaga() {
  yield all([fork(wathcAddItem), fork(wathcCreateItem), fork(watchGetListDelta), fork(watchInvokeKey), fork(wathcEaseeGetAdminUser)]);
}
